import { Chip, Tooltip, Typography } from '@mui/material'
import { People as PeopleIcon } from '@mui/icons-material'
import { Contact } from '../../services/api'
import { contactsForJob, contactDisplayName } from './warmContacts'

export { warmContactsAt, contactsForJob, orderWarmContacts, contactDisplayName } from './warmContacts'

/**
 * Inline warm-contacts indicator for a table row: a count chip whose tooltip
 * lists the names. Renders an em-dash when the client has no contacts at the
 * company. stopPropagation so clicking it doesn't open the row's drawer.
 */
export default function WarmContactsCell({
  contacts,
  company,
  linkedContactIds,
}: {
  contacts: Contact[]
  company?: string
  linkedContactIds?: string[]
}) {
  const warm = contactsForJob(contacts, company, linkedContactIds)
  if (warm.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    )
  }
  const names = warm.map(contactDisplayName)
  // MWA-237 — when there's a single warm contact, show their name (better CX
  // than a bare "1"); fall back to a count chip for 2+.
  const label = warm.length === 1 ? names[0] : warm.length
  return (
    <Tooltip title={names.join(', ')}>
      <Chip
        size="small"
        icon={<PeopleIcon sx={{ fontSize: 14 }} />}
        label={label}
        variant="outlined"
        color="success"
        onClick={(e) => e.stopPropagation()}
        sx={{ maxWidth: 160 }}
      />
    </Tooltip>
  )
}
